{
  "<0>Add {!site ? 'Google, or Facebook' : site === ReviewsTypes.Site.Google ? 'Google' : 'Facebook'}</0>": "<0>Add {!site ? 'Google, or Facebook' : site === ReviewsTypes.Site.Google ? 'Google' : 'Facebook'}</0>",
  "Add Review Platform": "Add Review Platform",
  "Add Text Signature": "Add Text Signature",
  "Add a public reply...": "Add a public reply...",
  "An error occurred while connecting to Google. Please try again.": "An error occurred while connecting to Google. Please try again.",
  "An error occurred while getting Facebook pages.": "An error occurred while getting Facebook pages.",
  "An error occurred while getting Google locations.": "An error occurred while getting Google locations.",
  "An error occurred while loading your settings.": "An error occurred while loading your settings.",
  "An error occurred while logging into Facebook.": "An error occurred while logging into Facebook.",
  "An error occurred while logging out of Facebook.": "An error occurred while logging out of Facebook.",
  "An error occurred while signing into Google. Please try again.": "An error occurred while signing into Google. Please try again.",
  "An error occurred while signing out of Google.": "An error occurred while signing out of Google.",
  "An error occurred while updating your signature. Please try again.": "An error occurred while updating your signature. Please try again.",
  "Apply Date Range": "Apply Date Range",
  "Are you sure you want to permanently delete this comment?": "Are you sure you want to permanently delete this comment?",
  "Are your ears ringing? People are talking about you.": "Are your ears ringing? People are talking about you.",
  "Back": "Back",
  "Cancel": "Cancel",
  "Choose a location from the above location picker to view review data.": "Choose a location from the above location picker to view review data.",
  "Clear": "Clear",
  "Clear All": "Clear All",
  "Click a review on the left to read and reply.": "Click a review on the left to read and reply.",
  "Confirm": "Confirm",
  "Connect To Facebook": "Connect To Facebook",
  "Connect To Google": "Connect To Google",
  "Create an auto response to the customer review": "Create an auto response to the customer review",
  "Custom Date Range": "Custom Date Range",
  "Delete Comment": "Delete Comment",
  "Delete Response": "Delete Response",
  "Doesn't Recommend": "Doesn't Recommend",
  "Edit Response": "Edit Response",
  "Edit Text Signature": "Edit Text Signature",
  "End Date": "End Date",
  "Error loading auto response": "Error loading auto response",
  "Facebook": "Facebook",
  "Facebook Reviews": "Facebook Reviews",
  "Facebook Reviews Summary": "Facebook Reviews Summary",
  "Facebook User": "Facebook User",
  "Facebook account integration cancelled": "Facebook account integration cancelled",
  "Filter Reviews": "Filter Reviews",
  "Google": "Google",
  "Google Reviews": "Google Reviews",
  "Google Reviews Summary": "Google Reviews Summary",
  "Google User": "Google User",
  "Google account integration cancelled": "Google account integration cancelled",
  "Got It!": "Got It!",
  "Haven't Replied": "Haven't Replied",
  "Hours": "Hours",
  "Invitations": "Invitations",
  "Learn More": "Learn More",
  "Location not selected.": "Location not selected.",
  "Locations": "Locations",
  "Logout of Facebook": "Logout of Facebook",
  "Logout of Google": "Logout of Google",
  "Manage your social settings": "Manage your social settings",
  "Newest": "Newest",
  "Next": "Next",
  "No Locations Found": "No Locations Found",
  "No Pages Found": "No Pages Found",
  "No Review Data Available.": "No Review Data Available.",
  "No address": "No address",
  "No review data to display.": "No review data to display.",
  "No reviews to display": "No reviews to display",
  "No written review.": "No written review.",
  "Not Recommended": "Not Recommended",
  "Number of Reviews": "Number of Reviews",
  "Oldest": "Oldest",
  "Optimize your business search engine ranking by including your business name in your public review replies.": "Optimize your business search engine ranking by including your business name in your public review replies.",
  "Popup blocked. Please allow popups for this site and try again.": "Popup blocked. Please allow popups for this site and try again.",
  "Previous": "Previous",
  "Private": "Private",
  "Read": "Read",
  "Read Status": "Read Status",
  "Recommended": "Recommended",
  "Recommends": "Recommends",
  "Replied": "Replied",
  "Replies": "Replies",
  "Reply": "Reply",
  "Reply Status": "Reply Status",
  "Replying to {{commenter}}...": "Replying to {{commenter}}...",
  "Request Review": "Request Review",
  "Request Reviews": "Request Reviews",
  "Review Account Not Connected.": "Review Account Not Connected.",
  "Review Invitations Sent": "Review Invitations Sent",
  "Review Replies": "Review Replies",
  "Reviews": "Reviews",
  "Reviews Analytics": "Reviews Analytics",
  "See next response": "See next response",
  "See previous response": "See previous response",
  "Select Facebook Page": "Select Facebook Page",
  "Select Google Location": "Select Google Location",
  "Select the office you wish to view your recommendations for.": "Select the office you wish to view your recommendations for.",
  "Shorten": "Shorten",
  "Show more": "Show more",
  "Sign In": "Sign In",
  "Sign in with your Google or Facebook business account to start tracking the health of your online reputation.": "Sign in with your Google or Facebook business account to start tracking the health of your online reputation.",
  "Signature": "Signature",
  "Signature successfully updated.": "Signature successfully updated.",
  "Social": "Social",
  "Social Platforms": "Social Platforms",
  "Sort": "Sort",
  "Start Date": "Start Date",
  "Submit": "Submit",
  "Successfully logged into Facebook.": "Successfully logged into Facebook.",
  "Successfully logged out of Facebook.": "Successfully logged out of Facebook.",
  "Successfully signed into Google.": "Successfully signed into Google.",
  "Successfully signed out of Google.": "Successfully signed out of Google.",
  "There is no review data available for the selected time period. Try selecting a different date range or check back later.": "There is no review data available for the selected time period. Try selecting a different date range or check back later.",
  "There's nothing that can stop you from becoming popular.": "There's nothing that can stop you from becoming popular.",
  "This Google account hasn't been granted admin permission for any Google My Business locations. To pair a location, have an Owner or the Primary Owner of the Google My Business location make you an Owner.": "This Google account hasn't been granted admin permission for any Google My Business locations. To pair a location, have an Owner or the Primary Owner of the Google My Business location make you an Owner.",
  "This Google account hasn’t been granted admin permission for any Google My Business locations. To pair a location, have an Owner or the Primary Owner of the Google My Business location make you an Owner.": "This Google account hasn’t been granted admin permission for any Google My Business locations. To pair a location, have an Owner or the Primary Owner of the Google My Business location make you an Owner.",
  "Time Range": "Time Range",
  "Time to Reply": "Time to Reply",
  "Total": "Total",
  "Total Reviews": "Total Reviews",
  "Try reloading the page. If the problem persists, contact Weave Support.": "Try reloading the page. If the problem persists, contact Weave Support.",
  "Unlink This Platform": "Unlink This Platform",
  "Unread": "Unread",
  "Update": "Update",
  "We encountered a problem while deleting your reply.": "We encountered a problem while deleting your reply.",
  "We encountered a problem while posting your reply.": "We encountered a problem while posting your reply.",
  "We encountered a problem while updating your reply.": "We encountered a problem while updating your reply.",
  "We weren't able to find any Facebook Pages to pull reviews from. Make sure you log into the correct Facebook account and then grant Weave permission to access reviews from the right Page.": "We weren't able to find any Facebook Pages to pull reviews from. Make sure you log into the correct Facebook account and then grant Weave permission to access reviews from the right Page.",
  "Weave AI": "Weave AI",
  "Weave User": "Weave User",
  "You do not have permission to edit responses.": "You do not have permission to edit responses.",
  "You do not have permission to edit social settings": "You do not have permission to edit social settings",
  "You do not have permission to reply.": "You do not have permission to reply.",
  "You do not have permission to send text messages": "You do not have permission to send text messages",
  "You do not have permission to view reviews analytics for any of the selected locations": "You do not have permission to view reviews analytics for any of the selected locations",
  "You do not have permission to view reviews analytics for this location": "You do not have permission to view reviews analytics for this location",
  "You do not have permission to view reviews for any of the selected locations": "You do not have permission to view reviews for any of the selected locations",
  "You do not have permission to view reviews for this location": "You do not have permission to view reviews for this location",
  "You must be an \"owner\" on your GoogleMyBusiness account in order to connect your account to Weave. Owners listed on your account are:": "You must be an \"owner\" on your GoogleMyBusiness account in order to connect your account to Weave. Owners listed on your account are:",
  "{{count}} Locations_one": "{{count}} Locations",
  "{{count}} Locations_other": "{{count}} Locations",
  "{{totalReviews}} Total Reviews": "{{totalReviews}} Total Reviews",
  "{{total}} {{unit}}": "{{total}} {{unit}}"
}
